export default function NotFound() {
    return (
        <div className="flex flex-col items-center justify-center h-screen font-sans text-ktx-purple gap-2">
            <h1 className="text-[36px]">404 - Page Not Found</h1>
            <h3 className="text-[24px] text-center max-w-[600px] mb-4">
                The page you are looking for does not exist.
            </h3>
            <a
                href="/"
                className="bg-ktx-purple hover:bg-ktx-navy text-white font-bold py-2 px-6 rounded-full shadow-lg transition-colors duration-200"
            >
                Return Home
            </a>
        </div>
    );
}